import axios, { AxiosError, AxiosInstance } from "axios"
import { notify } from "misc/notifications"
import { getBaseUrl } from "misc/util"
import Cookies from "universal-cookie"

const axiosClient: AxiosInstance = axios.create({
  baseURL: getBaseUrl(),
})

// Событие "сессия недействительна": AuthContext ловит его и показывает форму
// входа на той же странице. Раньше на 401 токен только стирался из cookie, а
// приложение оставалось открытым — пользователь видел вечный лоадер.
export const UNAUTHORIZED_EVENT = "auth:unauthorized"

// Раньше cookie токена ставился без path, то есть на путь страницы, где
// вошли (например, /mapping/result/iteration). Такой старый cookie браузер
// отдаёт раньше нового с path "/", и после входа уходил протухший токен —
// 401 и снова форма входа. Стираем token на "/" и на всех путях-родителях
// текущей страницы.
export const clearUserToken = () => {
  const cookies = new Cookies()
  const parts = window.location.pathname.split("/").filter(Boolean)
  const paths = ["/", ...parts.map((_, i) => `/${parts.slice(0, i + 1).join("/")}`)]
  paths.forEach((path) => {
    cookies.remove("token", { path })
    cookies.remove("token", { path: `${path}/` })
  })
}

axiosClient.interceptors.request.use(async (config) => {
  const cookies = new Cookies()
  const token = cookies.get("token")

  if (token) {
    config.headers["Authorization"] = `Bearer ${token.access_token}`
  }

  return config
})

axiosClient.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const statusCode = error.response?.status
    if (error.response?.status === 401) {
      clearUserToken()
      window.dispatchEvent(new Event(UNAUTHORIZED_EVENT))
      return
    }
    // Show notification if Internal Service Error
    if (statusCode === 500) {
      notify("Сервис сейчас недоступен, попробуйте позже или сообщите нам", "error")
      return
    }

    throw error
  },
)

export default axiosClient
